export default function BrandStory() {
  return (
    <section className="bg-warm-cream py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="font-sans text-charcoal-500 text-xs tracking-[0.3em] uppercase">Who We Are</span>
            <h2 className="font-serif text-charcoal-900 text-4xl md:text-5xl mt-3 mb-4 leading-tight">Built on Quality,<br />Driven by Detail</h2>
            <div className="w-20 h-0.5 bg-gold mb-6" />
            <p className="font-sans text-charcoal-600 text-base leading-relaxed mb-5">
              Hometown Painters is a professional painting company based in <strong className="text-charcoal-900">Elk Grove Village, Illinois</strong>. We specialize in residential and commercial painting services throughout the Chicago suburbs, with a focus on clean execution, durable finishes, and detail-oriented craftsmanship on every project.
            </p>
            <p className="font-sans text-charcoal-600 text-base leading-relaxed mb-5">
              Led by Dan, our team brings hands-on knowledge and a client-first approach to every job — from single-room interior refreshes to full-building HOA renovations. Our goal is simple: make sure every client is completely satisfied with the result.
            </p>
            <p className="font-sans text-charcoal-600 text-base leading-relaxed mb-8">
              We&apos;re proud to serve Elk Grove Village, Arlington Heights, Des Plaines, Bloomingdale, Schaumburg, Park Ridge, and surrounding Illinois communities with the same standard of quality on every project, large or small.
            </p>
            <div className="flex flex-col gap-3">
              {['1451 Landmeier Rd Unit G-B, Elk Grove Village, IL 60007','(847) 870-1600','sales@hometownpainters.com'].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full" />
                  <span className="font-sans text-charcoal-700 text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden h-[500px]">
            <img
              src="https://public.readdy.ai/ai/img_res/56eb06d732d2f2042e3bedff13a878a9.jpg"
              alt="Hometown Painters team Elk Grove Village IL"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
